import { dateTimeFromServer } from '../utils/format'
import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class BankSlip extends PaymentMethod {
  readonly number: string
  readonly formattedExpirationDate: string
  readonly barcodeBase64Image: string
  readonly sentTo: string

  constructor(data: JSON) {
    super(data)
    this.number = data.number
    this.formattedExpirationDate = dateTimeFromServer(this.expirationDate, false)!
    this.barcodeBase64Image = data.barcode_base64_image
    this.sentTo = data.sent_to
  }
}
